import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { refresh } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/admin-login", { email, password });
      await refresh();
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App" data-testid="admin-login-page">
      <Nav />
      <section className="min-h-[70vh] flex items-center justify-center py-24">
        <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="max-w-md mx-auto px-6 md:px-12 w-full">
          <p className="eyebrow mb-6">Admin</p>
          <h1 className="h-display text-4xl md:text-5xl mb-4">Sign in.</h1>
          <p className="text-prose mb-10">Manage scenarios, customers, and access links.</p>
          <form onSubmit={submit} className="card-soft p-8" data-testid="admin-login-form">
            <label className="eyebrow block mb-2">Email</label>
            <input type="email" className="input-line mb-6" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
            <label className="eyebrow block mb-2">Password</label>
            <input type="password" className="input-line mb-8" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
            <button disabled={loading} className="btn-primary w-full" data-testid="admin-submit">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </motion.div>
      </section>
      <Footer />
    </div>
  );
}
